export default class UpdateVariableModel {
	IdNVariable: number | null;
	IdNTipoVariableWEB: number | null;
	Valor: string | null;
	IdNTipoVariable: number | null;
	IdNSupervisor: number | null;
	IdNTipoSupervisor: number | null

	constructor(data: any) {
		this.IdNVariable = null;
		this.IdNTipoVariableWEB = null;
		this.Valor = null;
		this.IdNTipoVariable = null;
		this.IdNSupervisor = null;
		this.IdNTipoSupervisor = null;

		Object.assign(this, data);
	}

}